/*import Banner_Her_Miga_House from "../../common/assets/hogar-8-1.png";
import Hero_Miga_Arrow from "../../common/assets/icon-arrow-dark.svg";*/
import { useLocation, useNavigate, useOutletContext } from "react-router-dom";
import ContractCard from "../../components/card/contractCard";
import { useFetchContract } from "../../common/services/sanitas/apiSanitasContract";
import Loading from "../../components/elements/loading";

const Banner_Her_Miga_House = "/documents/d/guest/hogar-8-1";
const Hero_Miga_Arrow = "/documents/d/guest/icon-arrow-dark";

const ContractPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { userSantias } = useOutletContext<{ userSantias: any }>();
    const payload = location.state?.payload || userSantias;
    console.log("payload", payload);
    const { data: cards, isLoading } = useFetchContract(payload.identityDocument, payload.identityDocumentTypeId);
    interface Card {
        identityDocument: string;
        identityDocumentTypeId: number;
        memberCode: number;
        contractId: number;
        contractNumber: string;
        planId: number;
        planName: string;
        insureFromContract: string;
        insureFrom: string;
        insureTo: string;
        contractStatusId: number;
        contractStatus: string;
        monthRenueva: number | null;
        planCategoryId: number;
        planCategory: string;
        paymentPeriodicityId: number;
        paymentPeriodicty: string;
        planTypeId: number;
        planType: string;
        subProductTypeId: number;
        subProductType: string;
        gracePeriodId: number;
        producTypeId: number;
        producType: string;
        cardProviderId: number | null;
        cardProviderDescription: string;
        excludedShortage: string | null;
        antiquity: number;
        clientId: number;
        client: string;
        brokerId: number;
        broker: string;
        gracePeriod: string;
        compositionFamily: number;
        medicalConditions: string;
    }

    interface Payload {
        card?: Card;
    }

    const handleCardClick = (card: Card) => {
        const updatedPayload: Payload = { ...payload, card };
        localStorage.setItem("userContrarDetail", JSON.stringify(card));
        navigate('/mi-perfil/detalle-contrato', { state: { payload: updatedPayload, documentonumero: payload.identityDocument, tipodedoc: payload.identityDocumentTypeId } });
    }
    return (
        <>  
            {isLoading && <Loading />}
            {!isLoading && (<>
                <section className="hero is-white">
                    <div className="padding-global z-index">
                        <div className="padding-section-small">
                            <div className="container-medium">
                                <div className="hero_wrp text-color-black">
                                    <div className="hero_box-blue">
                                        <div className="hero_miga text-color-black">
                                            <img src={Banner_Her_Miga_House} loading="lazy" alt="" className="banner_her-miga-house" />
                                            <img src={Hero_Miga_Arrow} loading="lazy" alt="" className="hero_miga-arrow" />
                                            <a className="hero_miga-item is-dark current">Mi seguro</a>
                                        </div>
                                        <div className="title-component">
                                            <h1 className="title text-color-azul">Mis seguros</h1>
                                            <div className="line-title"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="reenbolso">
                    <div className="padding-global">
                        <div className="padding-section-medium">
                            <div className="container-medium">
                                <div className="reenbolso_wrp">
                                    <div className="seguros_grid">
                                        {cards.value.map((card: Card) => (
                                            <ContractCard
                                                key={card.planId}
                                                planId={card.planId}
                                                insureFromContract={card.insureFromContract}
                                                producType={card.producType}
                                                contractNumber={card.contractNumber}
                                                client={card.client}
                                                onClick={() => handleCardClick(card)}
                                            />
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </>)
            }
        </>
    );
}

export default ContractPage;